import zhCNLocale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import koKRLocale from 'ant-design-vue/es/date-picker/locale/ko_KR';
import enUSLocale from 'ant-design-vue/es/date-picker/locale/en_US';

/**
 * SPEC-CHINA-ADMIN-LOCALE-CC-C
 *
 * ant-design-vue DatePicker `:locale` prop을 i18n locale에 따라 동적 바인딩하는 mixin.
 *
 * 사용 예 (Options API):
 *   import { antDateLocaleMixin } from '@/mixins/antDateLocaleMixin';
 *   export default {
 *     mixins: [antDateLocaleMixin],
 *     // template: <a-date-picker :locale="antDateLocale" />
 *   };
 *
 * 효과: 신규 DatePicker 사용 컴포넌트에서 mixin 1줄로 자동 적용. 3 ant-design-vue
 *       import + computed 패턴 dedup. SPEC-CHINA-ADMIN-ANT-LOCALE-002의 컴포넌트
 *       `:locale` prop override 결함 재발 차단.
 *
 * @MX:ANCHOR antDateLocaleMixin — ProductsList/CertificateList/FollowerList + 신규
 */
export const antDateLocaleMixin = {
  computed: {
    antDateLocale() {
      const lang = this.$i18n.locale;
      if (lang === 'ko') return koKRLocale;
      if (lang === 'en') return enUSLocale;
      return zhCNLocale;
    },
  },
};
